/**
 * AccountListItem Component
 *
 * Reusable list item for displaying an account in list views.
 * Used by both desktop list panel and mobile list page.
 */

import React from 'react';

import { Card, CardBody } from '@enfomentis/ui';

import type { Account } from '@/types/schema/Account';

interface AccountListItemProps {
  account: Account;
  isSelected: boolean;
  onSelect: () => void;
}

export const AccountListItem: React.FC<AccountListItemProps> = ({
  account,
  isSelected,
  onSelect,
}) => {
  return (
    <Card
      isPressable
      isHoverable
      onPress={onSelect}
      className={`w-full ${
        isSelected
          ? 'border-primary bg-primary-50'
          : 'border-default-200 hover:border-default-300'
      }`}
      radius="sm"
      shadow="none"
    >
      <CardBody className="py-3 px-4">
        <div className="flex items-center justify-between">
          <span
            className={`font-medium ${
              isSelected ? 'text-primary' : 'text-text-primary'
            }`}
          >
            {account.name}
          </span>
          {account.status === 'archived' && (
            <span className="text-xs text-text-tertiary">Archived</span>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
